import styled from 'styled-components'

export const Container = styled.picture`
  ${({ theme }) => theme.textStyles.textSmall} // for the alt
  color: ${({ theme }) => theme.colors.matterhorn}; // for the alt
`
